<template>
<section id="mod-how_works" :class="['pt-page','pt-page-2','mod-how_works',
    meanList[3].clicked ? 'pt-page-current' : '',
    meanList[3].leave ? 'pt-page-moveToTop pt-page-current':'',
    meanList[3].enter ? 'pt-page-scaleUp':'']"><!-- Webpartzones --><!-- Webparts -->
<div class="mod-section-how-works content-container">
  <h2><span class="first"><span class="active"><span>联系方式：</span></span></span></h2>
  <div class="base clearfix anim">
    <div class="step-1">
      <div class="clearfix">
        <svg xmlns="http://www.w3.org/2000/svg" id="Ebene_1" data-name="Ebene 1" viewbox="0 0 107.75 53" class="svg replaced-svg"><title>icon_01</title><rect class="cls-1" x="1.5" y="1.5" width="30.67" height="50" rx="5" ry="5"></rect><circle class="st0" cx="16.8" cy="43.8" r="2.6"></circle><rect class="cls-1" x="75.58" y="9.6" width="30.67" height="37" rx="5" ry="5"></rect><path class="cls-1" d="M99.12 25.21H85.84v-5.14A2.17 2.17 0 0 1 88 17.9h9a2.17 2.17 0 0 1 2.17 2.17v5.14z" transform="translate(-1.56 -16.34)"></path><path class="cls-3" d="M81.29 48.68v2.75M100.29 48.68v2.75M53.35 18.85L61 26.5l-7.65 7.65M61 26.5H45.63"></path></svg>
      </div>
      <p>
        手机号：15828274523
      </p>
    </div>
    <div class="step-2">
      <div class="clearfix">
        <svg xmlns="http://www.w3.org/2000/svg" id="Ebene_1" data-name="Ebene 1" viewbox="0 0 33.67 82.58" class="svg replaced-svg"><title>icon_02</title><rect class="cls-1" x="1.5" y="1.5" width="30.67" height="79.58" rx="5" ry="5"></rect><path class="cls-2" d="M26.9 34.81H7.52M26.9 41.81H7.52M26.9 48.81H7.52M24.21 26.5V7.13M17.21 26.5V7.13M10.21 26.5V7.13"></path></svg>
      </div>
      <p>
        QQ：1061087497（昵称空）
      </p>
    </div>
    <div class="step-3">
      <div class="clearfix">
        <svg xmlns="http://www.w3.org/2000/svg" id="Ebene_1" data-name="Ebene 1" viewbox="0 0 53.88 46.77" class="svg replaced-svg"><title>icon_03</title><rect class="cls-1" x="6.54" y="1.5" width="37" height="30.67" rx="5" ry="5"></rect><path class="cls-1" d="M72.77 42.93V29.65h5.14a2.17 2.17 0 0 1 2.17 2.17v8.95a2.17 2.17 0 0 1-2.17 2.17h-5.14z" transform="translate(-28.5 -19.45)"></path><path class="cls-2" d="M4.46 7.21H1.71M4.46 26.21H1.71M52.38 42.13H1.5M24.68 9.19l7.65 7.64-7.65 7.65M32.33 16.83H16.96M4.44 45.27v-2.43M14.44 45.27v-2.43M24.44 45.27v-2.43M34.44 45.27v-2.43M44.44 45.27v-2.43M9.44 45.27v-2.43M19.44 45.27v-2.43M29.44 45.27v-2.43M39.44 45.27v-2.43M49.44 45.27v-2.43"></path></svg>
      </div>
      <p>
        微信：ww-930912（昵称阿伟）
      </p>
    </div>
  </div>
  <div class="button-wrapper anim">
    <a class="cta button" href="https://www.vmartaw.com/zcc/about.html" target="_blank" title="">关于我的</a>
  </div>
</div>
</section>
</template>

<script>
export default {
  props:['pageBoolean','meanList'],
  data(){
    return{
      progressWidth:{
        width:0
      },
      pageText:{
        time:0,
      },
      currentBoolean:{
        isFullPlay:false,
        toggleFullPlay:false,
        toggleFullPlayMuted:false
      }
    }
  },
  methods:{
    canplay(){
      var video=document.getElementById('loopVideo');
      //console.log('可以开始播放了');
      this.pageBoolean.showLoad=false;
      video.style.width=window.innerWidth+'px';
      video.play();
    },
    toggleFullPlay(){
      var fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlay=!this.currentBoolean.toggleFullPlay;
      if(this.currentBoolean.toggleFullPlay){
        this.progressBarVal();
        fullVideo.pause();
      }else{
        fullVideo.play();
      }
    },
    toggleFullPlayMuted(){
      var fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlayMuted=!this.currentBoolean.toggleFullPlayMuted;
      fullVideo.muted=this.currentBoolean.toggleFullPlayMuted;
    },
    canFullPlay(){
      var video=document.getElementById('loopVideo'),fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay=true;
      //console.log('大屏播放');
      video.pause();
      fullVideo.play();
    },
    closeFullPlay(){
      var video=document.getElementById('loopVideo'),fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay=false;
      this.currentBoolean.toggleFullPlay=false;
      //console.log('关闭播放');
      fullVideo.pause();
      video.play();
    },
    progressBarVal(){
      var fullVideo=document.getElementById('fullVideo');
      //console.log(fullVideo.currentTime.toFixed(0) +'秒');
      this.pageText.time=this.showTime(fullVideo.currentTime.toFixed(0));
      this.progressWidth.width=(fullVideo.currentTime / fullVideo.duration*100).toFixed(5)+'%';
      //console.log((fullVideo.currentTime / fullVideo.duration*100).toFixed(5)+'%');
    },
    getProgressBar(e){
      var fullVideo=document.getElementById('fullVideo'),fullBar=document.getElementById('fullBar'),
      precent=(e.clientX/fullBar.clientWidth).toFixed(5),currentTime=0;
      currentTime=fullVideo.duration*precent;
      //console.log(fullVideo.duration);//总时间
      //console.log(e.clientX);//选择的长度
      //console.log(fullBar.clientWidth);//总长度
      fullVideo.currentTime=currentTime;
      //console.log(currentTime);
    },
    showTime(time){
      var timeStr="";
      if(time < 10){
        timeStr="0:0"+time;
      }else if(time < 60){
        timeStr="0:"+time;
      }else{
        if(time % 60 < 10){
          timeStr=Math.floor(time/60)+":0"+time % 60;
        }else{
          timeStr=Math.floor(time/60)+":"+time % 60;
        }
      }
      return timeStr;
    }
  }
}
</script>



// WEBPACK FOOTER //
// Contact.vue?64ca2f5f